export const DIVIDEND_PAYMENT_INVESTOR_BATCH_SIZE = 100;
